module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"404","notFound":"Page Not Found","description":"The page you are looking for cannot be found."},"de":{"title":"404","notFound":"Seite nicht gefunden","description":"Die angeforderte Seite konnte leider nicht gefunden werden."}}')
  delete Component.options._Ctor
}
